<template>
  <scroll-view class="renew-index" :scroll="true" v-if="info != null">
    <div class="renew-flex-text">会员续费提醒</div>
    <div class="renew-flex-box">续费等级:{{ info.name }},续费金额:{{ info.amount }},续费期限:1年</div>
    <div class="renew-flex-button" @click="moreTap()">去支付</div>
  </scroll-view>
</template>

<script>
import { Albumlevelgetinfo, AlbumdonekeepAccountOrder, Albumpaypay } from '@/request/api.js';
export default {
  data() {
    return {
      info: null
    };
  },
  created() {
    this.Albumlevelgetinfo_load();
    typeof WeixinJSBridge != 'undefined' && WeixinJSBridge.call('hideOptionMenu');
  },
  methods: {
    async Albumlevelgetinfo_load() {
      let res = await Albumlevelgetinfo('');
      this.info = res.data;
    },
    moreTap() {
      let _self = this;
      this.$api.Message('提示', '是否续费?').then(res => {
        if (res) {
          AlbumdonekeepAccountOrder('').then(data => {
            let param = {
              order_id: data.data.order_id,
              payment_type: 'wx',
              param_type: '/contactCatalog/index',
			  openid:_self.$store.state.openid
            };
            _self.$api.pay(Albumpaypay, param);
          });
        }
      });
      //history.go(-1);
    }
  }
};
</script>

<style lang="less">
.renew-index {
  font-size: 1.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f4f4f4;

  .renew-flex-box {
    width: 90%;
    background-color: #ffffff;
    padding: 1rem 2%;
    margin-left: 3%;
    box-shadow: 0px 0px 10px #d5d6d8;
    margin-bottom: 3rem;
  }

  .renew-flex-text {
    width: 90%;
    margin-bottom: 0.2rem;
    padding: 0.5rem 2%;
    margin-left: 3%;
    color: #999;
    margin-top: 3rem;
  }

  .renew-flex-button {
    width: 90%;
    background-color: #2590c8;
    color: #ffffff;
    padding: 1rem 2%;
    border-radius: 0.5rem;
    text-align: center;
    margin-left: 3%;
  }
}
</style>
